<!-- eslint-disable vue/multi-word-component-names -->
<script setup>
const { onMounted, ref } = require("@vue/runtime-core");
const { default: axios } = require("axios");
const { useStore } = require("vuex");
import LogoFooter from "../assets/logo-kemenparekraf.png";

let store = useStore();
let setting = ref(null);

onMounted(() => {
  axios.get(`${store.state.urlAuth}setting`).then((res) => {
    setting.value = res.data.data;
  });
});
</script>

<style>
.footer-send-email {
  background-color: transparent;
  color: #ffffff;
}

.footer-send-email::placeholder {
  color: white;
  font-weight: bold;
}

.footer-send-email:focus {
  background-color: transparent;
  outline: none;
  box-shadow: none;
  border: none;
  color: #ffffff;
  font-weight: bold;
}

.footer-text-black {
  color: #122B4F;
  font-weight: bold;
}

a.footer-text-black:hover {
  color: #ffffff;
}
</style>
<template>
  <footer class="footer mt-auto py-5 bg-warning-mice mt-5" style="">
    <div class="container">
      <div class="row">
        <div class="col-lg-3">
          <div class="row footer-text-black">
            <div class="col-lg-12 mb-2 text-lg-start text-center">
              <img :src="setting?.logo_formated || LogoFooter" alt="" class="img-fluid" width="100" height="100" />
            </div>
            <div class="col-lg-12 mb-4 text-lg-start text-center">
              {{ setting?.name }}
            </div>
            <div class="col-lg-12 mb-3 text-lg-start text-center" v-if="setting != null">
              <a :href="data.link" target="_blank" class="btn btn-light rounded-circle mx-1"
                v-for="(data, i) in setting.sosmed" :key="i">
                <i :class="`${data.icon} fa-1x`"></i>
              </a>
            </div>
          </div>
        </div>
        <div class="col-lg-3 d-none d-lg-block">
          <div class="row footer-text-black">
            <div class="col-lg-12 my-2">
              <a class="text-decoration-none footer-text-black" href="/mice-indonesia">Tentang MICE.id</a>
            </div>
            <div class="col-lg-12 my-2">
              <router-link class="text-decoration-none footer-text-black" :to="{ name: 'ContactUs' }">Hubungi
                Kami</router-link>
            </div>
            <div class="col-lg-12 my-2">
              <router-link class="text-decoration-none footer-text-black" :to="{ name: 'Faq' }">FAQ</router-link>
            </div>
            <div class="col-lg-12 my-2">
              <a class="text-decoration-none footer-text-black" href="/coming-soon">Fitur</a>
            </div>
            <div class="col-lg-12 my-2">
              <a class="text-decoration-none footer-text-black" href="/coming-soon">Berita</a>
            </div>
            <div class="col-lg-12 my-2">
              <a class="text-decoration-none footer-text-black" href="/coming-soon">Pengumuman</a>
            </div>
          </div>
        </div>
        <div class="col-lg-3 d-none d-lg-block">
          <div class="row footer-text-black" v-if="setting != null">
            <div class="col-lg-12 my-2" v-for="(data, i) in setting.other_link" :key="i">
              <a class="text-decoration-none footer-text-black" :href="data.link" target="_blank">{{ data.name }}</a>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="row">
            <div class="col-lg-12 mt-2 footer-text-black">
              <h6 class="text-lg-start text-center">
                {{ $t('footerStayUpdated') }}
              </h6>
            </div>
            <div class="col-lg-12 mt-2">
              <div class="input-group mb-3 shadow-sm border-0 p-2"
                style="border-radius: 2rem; background-color: #ffffff52;">
                <input type="text" class="form-control border-0 footer-send-email" aria-describedby="input-group"
                  style="" :placeholder="$t('footerEnterYourEmail')" />
                <span class="input-group-text border-0 bg-primary-mice px-4" style="border-radius: 2rem;"
                  id="input-group">
                  <i class="fas fa-location-arrow text-white"
                    style="display: inline-block;transform: rotate(38deg);font-size: 19px;"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
